import React from 'react';
import ConditionUserTarget from './condtion-user-target';
import ConditionAppVersion from './condition-app-version';

const ConditionComps = {
  TARGET_USER: ConditionUserTarget,
  TARGET_APP_VERSION: ConditionAppVersion
};

export default function ConditionForm(props) {
  const { condition } = props;

  const TargetCondition = ConditionComps[condition.conditionType];

  return (
    <>
      {null}
      <TargetCondition {...props} />
    </>
  );
}
